import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCheck = function SvgCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M901 110.5c26.9-28.7 71.8-30.1 100.5-3.2s30.1 71.8 3.2 100.5L343.4 913.5C330 927.9 311.2 936 291.6 936h-1.2c-20.1-.3-39.2-9.2-52.3-24.3L17.6 659.6C-8.3 630.1-5.3 585 24.3 559.3c29.5-25.9 74.6-22.9 100.3 6.7l168.8 193z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);

export { ForwardRef as default };
